import { endpoint, EndpointError } from '../endpoint';

export type ExportHotelsResult = Buffer;
export type ExportHotelsError = EndpointError;

export const exportHotels = endpoint<void, ExportHotelsResult, ExportHotelsError>({
  method: 'GET',
  url: () => `/csv/export-hotels`,
});
